// hooks/useNotePermissions.ts

import {
    REALM_INTERN,
    UseKeycloakCheckRole,
    UseKeycloakService,
} from '@europrocurement/l2d-keycloak';

type NotePermissions = {
    canEdit: boolean;
    canDelete: boolean;
    hasAnyPermission: boolean;
};

export const useNotePermissions = (noteCreatedBy: string): NotePermissions => {
    const kc = UseKeycloakService();
    const roleChecker = UseKeycloakCheckRole();

    const currentUserEmail = kc.getEmail();

    // L'utilisateur est le créateur de la note
    const isNoteOwner = currentUserEmail === noteCreatedBy;

    // L'utilisateur est un responsable (Responsible)
    const isResponsible = roleChecker(REALM_INTERN);

    // Permissions : propriétaire de la note OU responsable
    const hasPermissions = isNoteOwner || isResponsible;

    return {
        canEdit: hasPermissions,
        canDelete: hasPermissions,
        hasAnyPermission: hasPermissions,
    };
};
